<template>
<div>
	<loading v-if="loadingFlag"></loading>
	<div fillHeight="lastHeight" scroll>
		<ul class="pl3x mb2x w85pct" >
			<li class="dpT w100pct pt1x pb1x">
				<div class="dpTC w6x">{{$t('word1383',['月份'])}}</div>
				<div class="dpTC">{{$t('word1109',['辐照度'])}} (kWh/㎡)</div>
			</li>
			<li class="dpT w100pct pt1x pb05x" v-for="(item,index) in irradiances" :key="index">
				<div class="dpTC w6x">{{item.month}}月</div>
				<input-text class="w30x input mr1x" v-model="item.irradiance" :only="'absNumber'" :ref="`month${index}`" :matchType="'floor2x'" :verification="'~:0~1000000'" @Blur="cal()" :isError="{error:errMsg.month[index].show}"></input-text>
				<!-- <div class="dpTC" :class="{cError:errMsg.month[index].show}" v-show="errMsg.month[index].show">{{errMsg.month[index].msg}}</div> -->
			</li>
			<li class="dpT w100pct pt1x pb1x">
				<div class="dpTC w6x">{{$t('word148',['合计'])}}</div>
				<div class="dpTC">{{floatFix(totalVal)}}</div>
			</li>
			<li class="dpT w100pct pt05x pb05x">
				<div class="dpTC w12x">{{$t('word1401',['理论'])}} PR(%)</div>
				<input-text class="w24x input mr1x" v-model="theoryPR" :only="'absNumber'" :default="theoryPR" :matchType="'percent'"></input-text>
				<!-- <div class="dpTC" :class="{cError:errMsg.theoryPR.show}" v-show="errMsg.theoryPR.show">{{errMsg.theoryPR.msg}}</div> -->
			</li>
			<li class="dpT w100pct pt05x pb05x">
				<div class="dpTC w12x">{{$t('word1397',['组件首年衰减'])}}(%)</div>
				<input-text class="w24x input mr1x" v-model="initAttenuation" :only="'absNumber'" :default="initAttenuation" :matchType="'percent'"></input-text>
				<!-- <div class="dpTC" :class="{cError:errMsg.initAttenuation.show}" v-show="errMsg.initAttenuation.show">{{errMsg.initAttenuation.msg}}</div> -->
			</li>		
			<li class="dpT w100pct pt05x pb05x">
				<div class="dpTC w12x">{{$t('word1398',['以后每年衰减'])}}(%)</div>
				<input-text class="w24x input mr1x" v-model="yearlyAttenuation" :only="'absNumber'" :default="yearlyAttenuation" :matchType="'percent'"></input-text>
				<!-- <div class="dpTC" :class="{cError:errMsg.yearlyAttenuation.show}" v-show="errMsg.yearlyAttenuation.show">{{errMsg.yearlyAttenuation.msg}}</div> -->
			</li>
			<li class="pt1x"><span class="ico-dvStatus-warning ui"></span> 1.{{$t('word1399',['计划每月发电量'])}}={{$t('word1109',['辐照度'])}} * {{$t('word1401',['理论'])}} PR * {{$t('word727',['装机容量'])}} *（1-{{$t('word1400',['组件衰减'])}}）</li>	
			<li class="pt1x"><span class="ico-dvStatus-warning ui"></span> 2.建议使用meteonorm的辐照数据，meteonorm地址:&nbsp;&nbsp;<a target="_blank" class="cMain" href="http://www.meteonorm.com/">http://www.meteonorm.com/</a></li>
		</ul>
		<div class="taC">
			<button class="functionBtn bdSub hover-bg-highLight w8x mt2x mr2x" type="button" @click="$emit('goBack')">{{$t('cmd85',['取消'])}}</button>
			<button class="functionBtn w8x mt2x mb2x" type="button" @click="save">{{$t('cmd84',['保存'])}}</button>
		</div>
	</div>
</div>
</template>
<script>
import { mapGetters,mapMutations,mapActions } from 'vuex'
import InputText from "@/components/common/ui/InputText"
import Loading from '@/components/common/ui/Loading'
import * as lib from "@/util/lib.js";

import {getLanguageStr} from "@/util/language"
import * as configApi from '@/api/maintain/config'
export default {
	name: 'stationPlanConfig',
	props: {
	},
	components:{
		InputText,
		Loading
	},
	data(){
		return{
			loadingFlag:true,
			theoryPR:80,
			initAttenuation:2.5,
			yearlyAttenuation:0.75,
			totalVal:0,
			irradiances:this.irradiancesData(),
			errMsg: {
				// theoryPR: { msg: getLanguageStr('phrase523+word1401+PR','请输入理论PR'), show: false },
				// initAttenuation: { msg:getLanguageStr('phrase523+word1397','请输入组件首年衰减'), show: false },
				// yearlyAttenuation: { msg: getLanguageStr('phrase523+word1398','请输入以后每年衰减'), show: false },
				month: [
					{ msg: i18n.t('plant320',[1,'请输入1月计划发电量']), show: false },
					{ msg: i18n.t('plant320',[2,'请输入2月计划发电量']), show: false },
					{ msg: i18n.t('plant320',[3,'请输入3月计划发电量']), show: false },
					{ msg: i18n.t('plant320',[4,'请输入4月计划发电量']), show: false },
					{ msg: i18n.t('plant320',[5,'请输入5月计划发电量']), show: false },
					{ msg: i18n.t('plant320',[6,'请输入6月计划发电量']), show: false },
					{ msg: i18n.t('plant320',[7,'请输入7月计划发电量']), show: false },
					{ msg: i18n.t('plant320',[8,'请输入8月计划发电量']), show: false },
					{ msg: i18n.t('plant320',[9,'请输入9月计划发电量']), show: false },
					{ msg: i18n.t('plant320',[10,'请输入10月计划发电量']), show: false },
					{ msg: i18n.t('plant320',[11,'请输入11月计划发电量']), show: false },
					{ msg: i18n.t('plant320',[12,'请输入12月计划发电量']), show: false },
				],
			}
		}
	},
	methods:{
		getLanguageStr,
		floatFix:lib.floatFix,
		irradiancesData(){
			let arr=new Array(12)
			$.each(arr,index=>{
				arr[index]={
					month:index+1,
					irradiance:""
				}
			})
			return arr
		},
		cal(){
			this.$nextTick(()=>{
				this.totalVal=0
				for(let k in this.irradiances){
					this.totalVal += Number(this.irradiances[k].irradiance)
				}
			})
		},
		reset:function(){
			this.loadingFlag=true;
			this.totalVal=0
			$.each(this.$refs,function(){//遍历范围内所有需要reset对象,以清除一些报错内容
				if(this[0]&&this[0].reset) this[0].reset();
			});
			$.each(this.irradiances,index=>{
				this.irradiances[index]={
					month:index+1,
					irradiance:""
				}
			})
			this.restError()
		},
		restError(){
			for(let attr in this.errMsg.month){
				this.errMsg.month[attr].show=false
			}
			// this.errMsg.theoryPR.show=false
			// this.errMsg.initAttenuation.show=false
			// this.errMsg.yearlyAttenuation.show=false
		},
		_getPlan(id){
			this.loadingFlag=true
			this.totalVal=0
			configApi.generatePlan(id).then(response=>{
				if(response){
					for(let attr in response.irradiances){
					this.totalVal += Number(response.irradiances[attr].irradiance)
					for(let k in this.irradiances){
						if(this.irradiances[k].month==response.irradiances[attr].month){
							this.irradiances[k].irradiance=response.irradiances[attr].irradiance
						}
					}
				}
				this.theoryPR=response.theoryPR
				this.initAttenuation=response.initAttenuation
				this.yearlyAttenuation=response.yearlyAttenuation
				}
				this.loadingFlag=false
			},error=>{
				this.loadingFlag=false
				!_.isEmpty(error) && this.$notify(error)
			})
		},
		save(){
			let num=0
			this.restError()
			for(let k in this.irradiances){
				if(this.irradiances[k].irradiance==""){
					this.errMsg.month[k].show=true
				}else{
					num++
				}
			}
			if(num==12){
				for(let attr in this.errMsg.month){
					this.errMsg.month[attr].show=false
				}
			}
			let allClear=true;
			$.each(this.$refs,function(){
				if(this[0]&&this[0].verification){//有时候某些组件隐藏掉会导致this为undefined
					let clear=this[0].doVerification();
					if(allClear) allClear=clear;
				}
			});
			// for(let ref in this.$refs){
			// 	if(this.$refs[ref][0].error="输入范围为0~10000000000")return false
			// }
			// if(!this.theoryPR){
			// 	this.errMsg.theoryPR.show=true
			// }else{
			// 	this.errMsg.theoryPR.show=false
			// }
			// if(!this.initAttenuation){
			// 	this.errMsg.initAttenuation.show=true
			// }else{
			// 	this.errMsg.initAttenuation.show=false
			// }
			// if(!this.yearlyAttenuation){
			// 	this.errMsg.yearlyAttenuation.show=true
			// }else{
			// 	this.errMsg.yearlyAttenuation.show=false
			// }
			if(num==12 && allClear){
				let reqirradiances=_.cloneDeep(this.irradiances)
				reqirradiances=reqirradiances.map(el=>({
					month:el.month,
					irradiance:Number(el.irradiance)
				}))
				let req={
					initAttenuation:this.initAttenuation,
					irradiances:[...reqirradiances],
					stationId:this.stationId,
					theoryPR:this.theoryPR,
					yearlyAttenuation:this.yearlyAttenuation
				}
				configApi.addGeneratePlan(this.stationId,req).then(response=>{
					this.$emit('afterSave')
				},error=>{
					!_.isEmpty(error) && this.$notify(error)
				})
			}
		},
	},
	mounted(){
	},
	computed:{
		...mapGetters({
			stationId: 'stationDetail/stationId',
		}),
	}
}
</script>
<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/view/maintain/light/plant/part/StationPlanConfig.vue